// extracted by mini-css-extract-plugin
export default {"cls1":"IBwIfpdqNThVdshmdPSY","cls2":"CjI8KN8ApEhx1e93JjVz IBwIfpdqNThVdshmdPSY"};